import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';

export async function updateMessage(
  chatRoomId: string,
  messageId: string,
  body: { files: FileBasic[] },
  token?: string
) {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/message/${messageId}`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return res;
}
